<div *ngIf="control" class="mb-5 w-full">
  <div class="flex justify-between">
    <label [for]="inputId" class="block text-sm font-medium leading-6 text-gray-900">{{ label }}</label>
  </div>
  <div class="relative mt-2 rounded-md shadow-sm">
    <input
      [formControl]="control"
      type="text"
      [name]="inputId"
      [id]="inputId"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [ngClass]="{
        'text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-red-500':
          control.touched && control.invalid
      }"
      (input)="onInput($event)"
      (keydown)="onKeydown($event)"
      autocomplete="off"
      class="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-primary sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200"
      [attr.aria-describedby]="inputId"
      [attr.aria-invalid]="(control.touched && control.invalid) ? true : null"
    />
    <div *ngIf="control.touched && control.invalid"
         class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
      <svg class="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
      </svg>
    </div>
    <div *ngIf="loading" class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
      <div class="lds-ring-sm">
        <div [ngStyle]="ringStyle"></div>
        <div [ngStyle]="ringStyle"></div>
        <div [ngStyle]="ringStyle"></div>
        <div [ngStyle]="ringStyle"></div>
      </div>
    </div>
    <ul
      *ngIf="showDropdown"
      class="absolute z-50 mt-1 w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg"
    >
      <li
        *ngFor="let suggestion of suggestions; let i = index"
        (mousedown)="selectSuggestion(suggestion)"
        (mouseenter)="activeIndex = i"
        class="cursor-pointer px-3 py-2 text-sm text-gray-700"
        [class.bg-gray-100]="activeIndex === i"
      >
        {{ suggestion.label }}
      </li>
      <li class="border-t border-gray-100 px-3 py-1 text-right text-xs text-gray-400">
        Powered by Google
      </li>
    </ul>
  </div>
  <a
    *ngIf="zillowUrl"
    [href]="zillowUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="mt-1 inline-block text-sm text-primary hover:underline"
  >
    View on Zillow ↗
  </a>
  <p *ngIf="control.invalid && (control.dirty || control.touched) && control.hasError('required')"
     class="mt-2 text-sm text-red-600">{{label || placeholder}} is required</p>
</div>
